import React from "react";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const Container: React.FC<ContainerProps> = ({
  children,
  className = "",
  id,
}) => {
  return (
    <div
      id={id}
      className={`bg-soluud-background-card border-soluud-border-subtle rounded-xl border p-5 shadow-[--shadow-card] transition-shadow duration-200 ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
